import defaultItems from '../../../../../common/defaultItems';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Spacer',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 30,
            paddingBottom: 30,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'SPACER',
                            content: {
                                ...defaultItems.SPACER.content,
                                containerBackgroundColor: '#CCCCCC',
                                height: 5,
                            },
                        },
                    ],
                },
            ],
        },
    };
}
